module.exports = __webpack_public_path__ + "img/3.2a385072.jpg";